/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Error_No_TriggerInputs */

const cs_workflow_error_no_trigger = /** @type {(inputs: Workflow_Error_No_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow musí mít právě jeden spouštěcí uzel.`)
};

const en_workflow_error_no_trigger = /** @type {(inputs: Workflow_Error_No_TriggerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow must have exactly one trigger node.`)
};

/**
* | output |
* | --- |
* | "Workflow must have exactly one trigger node." |
*
* @param {Workflow_Error_No_TriggerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_error_no_trigger = /** @type {((inputs?: Workflow_Error_No_TriggerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Error_No_TriggerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_error_no_trigger(inputs)
	return cs_workflow_error_no_trigger(inputs)
});